module.exports = __webpack_public_path__ + "img/ip-img2.1d1c6024.png";